import React, { useState } from 'react'
import { FaTimesCircle } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

import { useStateContext } from '../../../state/context'
import { setDrugCategory } from '../../../state/actions/actions'
import { deleteWard } from '../../../state/actions/admin.actions'
import { deleteDrugCategory } from '../../../state/actions/pharmacist.actions'
import ButtonLoader from '../../utils/ButtonLoader'


const PharmacistDeleteDrugCategoryModal = () => {
    const dispatch = useDispatch();

    const { modals, setModals } = useStateContext()

    const { drug_category_update } = useSelector((state) => state.root)
    const { pharmacistLoading } = useSelector((state) => state.pharmacist)

    const handleSubmit = (e) => {
        e.preventDefault()

        dispatch(deleteDrugCategory({ id: drug_category_update?.id, toast, setModals, modals, dispatch, setDrugCategory }));
    }
    return (
        <div className="fixed grid h-screen w-full z-10 bg-[#11111180] place-items-center">
            <div className="bg-white w-[500px] rounded px-[30px] py-[20px]">
                <div className="flex flex-col space-y-5">
                    <div className="flex justify-between items-center">
                        <h4 className='text-dark-green text-[20px] font-bold'>Delete</h4>
                        <FaTimesCircle
                            className='text-dark-yellow cursor-pointer'
                            onClick={() => {
                                dispatch(setDrugCategory({ data: null }))
                                setModals({ ...modals, showPharmacistUpdateDeleteCategoryModal: !modals.showPharmacistUpdateDeleteCategoryModal })
                            }}
                            size={20}
                        />
                    </div>

                    <form onSubmit={handleSubmit}>
                        <p className="text-left">Are you sure you want to delete the drug category <span className='font-bold italic'>{drug_category_update?.category}</span>?</p>

                        <div className='mt-4 flex justify-end'>
                            <button
                                type='submit'
                                className="inline-block w-[175px] px-6 py-2.5 bg-dark-yellow text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                            >
                                {!pharmacistLoading ? (
                                    'Delete'
                                ) : (
                                    <ButtonLoader />
                                )}
                            </button>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    )
}
export default PharmacistDeleteDrugCategoryModal


